import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MessageSquarePlus } from "lucide-react";
import LeadCaptureForm from "@/components/LeadCaptureForm";

// Site-wide floating lead capture button. Sits bottom-left so it doesn't
// collide with the bottom-right FloatingWhatsApp button.
export default function FloatingLeadCapture() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 left-6 z-40 bg-[#0F172A] hover:bg-[#1E293B] text-white rounded-full p-4 shadow-xl transition-transform hover:scale-105"
        aria-label="Get in touch"
        data-testid="floating-lead-btn"
      >
        <MessageSquarePlus className="w-6 h-6" />
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="floating-lead-dialog">
          <DialogHeader>
            <DialogTitle className="text-2xl">Get in touch</DialogTitle>
            <DialogDescription>Drop your details and we&apos;ll reach out shortly.</DialogDescription>
          </DialogHeader>
          <LeadCaptureForm testId="floating-lead-form" compact onSuccess={() => setTimeout(() => setOpen(false), 1500)} />
        </DialogContent>
      </Dialog>
    </>
  );
}
